// eslint-disable-next-line import/prefer-default-export
export const STATUT_DECLARATION_A_COMPLETER = 'à compléter';
